import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	requiredMessage: {
		id: `eoc.common.validators.requiredMessage`,
		defaultMessage: `This field is required`,
		description: 'The text will be displayed in required form fields',
	},
	validMaxLengthMessage: {
		id: `eoc.common.validators.validMaxLengthMessage`,
		defaultMessage: `You have exceeded the maximum character limit`,
		description: 'The text will be displayed when maximum length for given text in form fields',
	},
	invalidEmailMessage: {
		id: `eoc.common.validators.invalidEmailMessage`,
		defaultMessage: `Please enter a valid e-mail`,
		description: 'The text will be displayed when given email is invalid in form fields',
	},
	invalidUrlMessage: {
		id: `eoc.common.validators.invalidUrlMessage`,
		defaultMessage: `Please enter a valid url`,
		description: 'The text will be displayed when given url is invalid in form fields',
	},
});
